import { Input } from "V2.0/common/input";
import { Textarea } from "V2.0/common/textarea";
import {
  Field,
  Label,
  Description,
  ErrorMessage,
} from "V2.0/common/fieldset";
import EvalRunConfigPersonaAttributes from "./EvalRunConfigPersonaAttributes";

export default EvalRunConfigPersonaForm;

function EvalRunConfigPersonaForm(props) {
  // Replaced: attribute rows report their own errors (per row + list-level).
  // const { formState, updateFormState, errors } = props;
  const { formState, updateFormState, errors, attributeErrors } = props;

  return (
    <div className="flex flex-col gap-y-8">
      <Field>
        <Label>Name *</Label>
        <Input
          type="text"
          value={formState.name}
          onChange={(e) => updateFormState("name", e.target.value)}
          invalid={!!errors.name}
        />
        {errors.name && <ErrorMessage>{errors.name}</ErrorMessage>}
      </Field>

      <Field>
        <Label>Description *</Label>
        <Textarea
          value={formState.description}
          onChange={(e) => updateFormState("description", e.target.value)}
          invalid={!!errors.description}
          rows={2}
          style={{fontSize: "13px"}}
        />
        {errors.description && (
          <ErrorMessage>{errors.description}</ErrorMessage>
        )}
      </Field>

      <Field>
        <Label>Scenario *</Label>
        <Textarea
          value={formState.scenario}
          onChange={(e) => updateFormState("scenario", e.target.value)}
          invalid={!!errors.scenario}
          style={{fontSize: "13px", height: "100px"}}
        />
        {errors.scenario && <ErrorMessage>{errors.scenario}</ErrorMessage>}
      </Field>

      <Field>
        <Label>Initial Message *</Label>
        <Textarea
          value={formState.initialMessage}
          onChange={(e) => updateFormState("initialMessage", e.target.value)}
          invalid={!!errors.initialMessage}
          style={{fontSize: "13px", height: "100px"}}
        />
        {errors.initialMessage && (
          <ErrorMessage>{errors.initialMessage}</ErrorMessage>
        )}
      </Field>

      <Field>
        <Label>Expected Output</Label>
        <Description>
          Optional — what the assistant should achieve with this persona.
        </Description>
        <Textarea
          value={formState.expectedOutput}
          onChange={(e) => updateFormState("expectedOutput", e.target.value)}
          invalid={!!errors.expectedOutput}
          placeholder="e.g. States the refund window, raises the request"
          style={{ fontSize: "13px", height: "100px" }}
        />
        {errors.expectedOutput && (
          <ErrorMessage>{errors.expectedOutput}</ErrorMessage>
        )}
      </Field>

      <EvalRunConfigPersonaAttributes
        rows={formState.attributes}
        rowErrors={attributeErrors?.rowErrors}
        error={attributeErrors?.error}
        onRowsChange={(rows) => updateFormState("attributes", rows)}
      />

      <Field>
        <Label>Interruption Rate</Label>
        <Input
          type="number"
          min={0}
          max={1}
          step={0.1}
          value={formState.interruptionRate}
          onChange={(e) =>
            updateFormState("interruptionRate", Number(e.target.value))
          }
          invalid={!!errors.interruptionRate}
        />
        {errors.interruptionRate && (
          <ErrorMessage>{errors.interruptionRate}</ErrorMessage>
        )}
      </Field>
    </div>
  );
}
